import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Segment,
  Item,
  Title,
  Icon,
  Grid,
  GridRow,
  GridColumn,
  Image,
} from "semantic-ui-react";
import { customdecodeURIComponent, getOrdinalSuffix } from "../../common/Utils";
import Link from "next/link";
import { relative } from "path";

const NhrankingList = ({
  itemData,
  prev,
  active,
  id,
  datamsg,
  onScroll,
  loading,
  isMobile,
  handlesummaryClick,
  ...props
}) => {
  let page_size = 10;
  let indexdata = (active - 1) * page_size;
  const ref = useRef();
  const handleScrollDiv = () => {
    const div = ref.current;
    onScroll(div);
  };

  return (
    <>
      {datamsg !== "" ? (
        <h3>{datamsg}</h3>
      ) : (
        <div className="scroller" ref={ref} onScroll={handleScrollDiv}>
          <Grid>
            {/* {itemData
            .slice(indexdata)
            .slice(0, page_size)
            .map((item, index) => { */}
            {itemData.map((item, index) => {
              let indexdata = itemData.findIndex(
                (itemData) => itemData.id === item.id,
              );
              let npiscore = 0;
              let schoolscore = 0;
              let safetyscore = 0;
              let amenitiesscore = 0;
              let pricescore = 0;
              let appereciationscore = 0;
              let domscore = 0;
              let valuescore = 0;
              let valuedata = 0;
              let thumbanail = "";
              let iscityDataAppriciation = false;
              let iscityDataPrice = false;

              if (parseFloat(item.npi) > 0) {
                npiscore = Number(((item.npi / 100) * 5).toFixed(2)).toFixed(1);
              } else {
                npiscore = "-";
              }

              if (parseFloat(item.school) > 0) {
                schoolscore = Number(
                  ((parseFloat(item.school) / 10) * 5).toFixed(2),
                ).toFixed(1);
              } else {
                schoolscore = "-";
              }

              if (item.appreciationCityFlag === 1) {
                valuescore = parseInt(item.valuescore_city);
                valuescore = "$" + valuescore.toLocaleString();
                valuescore = valuescore.replace("-", "");
                valuedata = parseInt(item.valuescore_city);
                iscityDataAppriciation = true;
              } else if (item.value) {
                valuescore = parseInt(item.value);
                valuescore = "$" + valuescore.toLocaleString();
                valuescore = valuescore.replace("-", "");
                valuedata = parseInt(item.value);
              } else {
                valuescore = "-";
                valuedata = "-";
              }

              if (item.appreciationCityFlag === 1) {
                appereciationscore = item.appreciation_city.toFixed(2) + " %";
                iscityDataAppriciation = true;
              } else if (parseFloat(item.appreciation) !== 0) {
                appereciationscore = item.appreciation.toFixed(2) + " %";
              } else {
                appereciationscore = "-";
              }

              if (parseFloat(item.crime) > 0) {
                safetyscore = Number(
                  ((parseFloat(item.crime) / 10) * 5).toFixed(2),
                ).toFixed(1);
              } else {
                safetyscore = "-";
              }

              if (item.amenities > 0) {
                amenitiesscore = item.amenities;
              } else if (item.walkability > 0) {
                amenitiesscore = Number(
                  ((item.walkability / 10) * 5).toFixed(2),
                ).toFixed(1);
              } else {
                amenitiesscore = "-";
              }

              if (
                item.medianPriceDomCityFlag === 1 &&
                parseFloat(item.cityMedianPrice) > 0
              ) {
                pricescore = "$" + item.cityMedianPrice.toLocaleString();
                iscityDataPrice = true;
              } else if (parseFloat(item.medianprice) > 0) {
                pricescore = "$" + item.medianprice.toLocaleString();
              } else {
                pricescore = "-";
              }

              if (parseFloat(item.dom) > 0) {
                domscore = item.dom;
              } else {
                domscore = "-";
              }

              if (item.imageurl && item.imageurl !== null) {
                thumbanail = item.imageurl;
              } else if (
                item.neighborhoodImages &&
                item.neighborhoodImages.length > 0 &&
                item.neighborhoodImages[0].imageurl
              ) {
                thumbanail = item.neighborhoodImages[0].imageurl;
              }

              let final_summary = "";
              if (item.reviewSummary && item.reviewSummary !== null) {
                final_summary = item.reviewSummary;
              }

              let keywords = "";
              if (item.keyword && item.keyword != "") {
                keywords = item.keyword;
              }
              let displaykey = process.env.NEXT_PUBLIC_DISPLAY_DATA;
              return (
                <>
                  {item[displaykey] === 1 ? (
                    isMobile === true ? (
                      <div className="ranking_wrapper">
                        <Grid>
                          <GridRow
                            className="nhranking_item_section"
                            key={item.id}
                          >
                            {" "}
                            {/* Add a key here */}
                            <GridColumn mobile={1} tablet={1} computer={1}>
                              <div className="nh_ranking_rating_mb">
                                {indexdata + 1}
                                <sup className="nh_ranking_suffix_mb">
                                  {getOrdinalSuffix(indexdata + 1)}
                                </sup>
                              </div>
                            </GridColumn>
                            <GridColumn mobile={7} tablet={4} computer={4}>
                              <a
                                href={`/Neighborhood/${item.nhfullname}`}
                                target="_blank"
                                className="nhrankking_img_mb"
                                data-testid={item.id}
                              >
                                <Image
                                  src={
                                    thumbanail !== ""
                                      ? thumbanail
                                      : "/static/images/defaultnhmap.jpg"
                                  }
                                  alt={item.nhfullname}
                                  title={item.nhfullname}
                                />
                              </a>
                            </GridColumn>
                            <GridColumn mobile={7} tablet={4} computer={4}>
                              <h4 className="ranking_label">
                                <a
                                  href={`/Neighborhood/${item.nhfullname}`}
                                  target="_blank"
                                  data-testid={item.id}
                                >
                                  {item.label}
                                </a>
                              </h4>
                              <p className="NhrankingP">
                                Overall Score : {npiscore}
                              </p>
                            </GridColumn>
                          </GridRow>
                          <GridRow
                            className="nhranking_item_desc"
                            key={`desc-${item.id}`}
                          >
                            {" "}
                            {/* Add a unique key here */}
                            <GridColumn
                              mobile={16}
                              tablet={11}
                              computer={14}
                              className="gridmargin"
                            >
                              <Grid className="gridmargin2">
                                <Grid.Row>
                                  <GridColumn
                                    mobile={6}
                                    tablet={8}
                                    computer={7}
                                  >
                                    <p className="NhrankingP">
                                      School : {schoolscore}
                                    </p>
                                    <p className="NhrankingP">
                                      Safety : {safetyscore}
                                    </p>
                                    <p className="NhrankingP">
                                      Amenities : {amenitiesscore}
                                    </p>
                                  </GridColumn>
                                  <GridColumn
                                    mobile={10}
                                    tablet={8}
                                    computer={7}
                                  >
                                    <p className="NhrankingP">
                                      Price : {pricescore}
                                    </p>
                                    <p className="NhrankingP">
                                      Appreciation : {appereciationscore}
                                    </p>
                                    <p className="NhrankingP">
                                      Value: {valuescore}
                                      {valuedata > 0 ? (
                                        <span className="overval">
                                          Overvalued
                                        </span>
                                      ) : valuedata < 0 ? (
                                        <span className="underval">
                                          Undervalued
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  </GridColumn>
                                </Grid.Row>
                              </Grid>
                            </GridColumn>
                          </GridRow>
                        </Grid>
                      </div>
                    ) : (
                      <div className="ranking_wrapper">
                        <Grid>
                          <GridRow className="nhranking_item" key={item.id}>
                            {" "}
                            {/* Add a key here */}
                            <GridColumn mobile={1} tablet={1} computer={1}>
                              <div className="nh_ranking_rating">
                                {indexdata + 1}
                                <sup className="nh_ranking_suffix">
                                  {getOrdinalSuffix(indexdata + 1)}
                                </sup>
                              </div>
                            </GridColumn>
                            <GridColumn mobile={6} tablet={7} computer={7}>
                              <a
                                href={`/Neighborhood/${item.nhfullname}`}
                                target="_blank"
                                className="nhrankking_img"
                                data-testid={item.id}
                              >
                                <Image
                                  src={
                                    thumbanail !== ""
                                      ? thumbanail
                                      : "/static/images/defaultnhmap.jpg"
                                  }
                                  alt={item.nhfullname}
                                  title={item.nhfullname}
                                />
                              </a>
                            </GridColumn>
                            <GridColumn mobile={9} tablet={8} computer={8}>
                              <Grid>
                                <Grid.Row style={{ paddingBottom: "0px" }}>
                                  <GridColumn
                                    mobile={8}
                                    tablet={16}
                                    computer={16}
                                  >
                                    <h3>
                                      <a
                                        href={`/Neighborhood/${item.nhfullname}`}
                                        target="_blank"
                                        data-testid={item.id}
                                      >
                                        {item.label}
                                      </a>
                                    </h3>
                                  </GridColumn>
                                </Grid.Row>
                                <p className="NhrankingP">
                                  Overall Score : {npiscore}
                                </p>
                                <Grid.Row>
                                  <GridColumn
                                    mobile={7}
                                    tablet={6}
                                    computer={6}
                                  >
                                    <p className="NhrankingP">
                                      School : {schoolscore}
                                    </p>
                                    <p className="NhrankingP">
                                      Safety : {safetyscore}
                                    </p>
                                    <p className="NhrankingP">
                                      Amenities : {amenitiesscore}
                                    </p>
                                  </GridColumn>
                                  <GridColumn
                                    mobile={8}
                                    tablet={8}
                                    computer={8}
                                  >
                                    <p className="NhrankingP">
                                      Price : {pricescore}
                                    </p>
                                    <p className="NhrankingP">
                                      Appreciation : {appereciationscore}
                                    </p>
                                    <p className="NhrankingP">
                                      Value: {valuescore}
                                      {valuedata > 0 ? (
                                        <span className="overval">
                                          Overvalued
                                        </span>
                                      ) : valuedata < 0 ? (
                                        <span className="underval">
                                          Undervalued
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  </GridColumn>
                                </Grid.Row>
                              </Grid>
                            </GridColumn>
                          </GridRow>
                          <Grid.Row
                            style={{ paddingTop: "0px" }}
                            key={`desc-${item.id}`}
                          >
                            {" "}
                            {/* Add a unique key here */}
                            <GridColumn
                              mobile={14}
                              tablet={1}
                              computer={1}
                            ></GridColumn>
                            <GridColumn mobile={14} tablet={15} computer={15}>
                              {keywords && (
                                <p className="nhrankingkeywords">
                                  <strong>Keywords:</strong>{" "}
                                  {keywords
                                    .split(",")
                                    .map((word) => word.trim())
                                    .join(", ")}
                                </p>
                              )}
                              <p className="nhrankingDesc">
                                {final_summary != "" && (
                                  <>
                                    {final_summary.length > 54 ? (
                                      <p className="nhpannel_desc nhdesc">
                                        {customdecodeURIComponent(
                                          final_summary.slice(0, 300),
                                        )}
                                        <span
                                          className="nhrankingsummary"
                                          onClick={(e) =>
                                            handlesummaryClick(item.nhfullname)
                                          }
                                        >
                                          {" "}
                                          ...See more
                                        </span>
                                      </p>
                                    ) : (
                                      <p className="nhpannel_desc nhdesc">
                                        {customdecodeURIComponent(
                                          final_summary,
                                        )}
                                      </p>
                                    )}
                                  </>
                                )}
                              </p>
                            </GridColumn>
                          </Grid.Row>
                        </Grid>
                      </div>
                    )
                  ) : (
                    <GridRow key={item.id}>
                      <GridColumn mobile={1} tablet={1} computer={1}>
                        <strong>#{indexdata + 1}</strong>
                      </GridColumn>
                      <GridColumn mobile={6} tablet={4} computer={4}>
                        <a
                          href={`/Neighborhood/${item.nhfullname}`}
                          target="_blank"
                          className="nhrankking_img"
                          data-testid={item.id}
                        >
                          <Image
                            src="/static/images/defaultnhmap.jpg"
                            alt={item.nhfullname}
                            title={item.nhfullname}
                          />
                        </a>
                      </GridColumn>
                      <GridColumn mobile={9} tablet={11} computer={11}>
                        <Grid>
                          <Grid.Row>
                            <GridColumn mobile={8} tablet={14} computer={14}>
                              <h3>
                                <a target="_blank" data-testid={item.id}>
                                  {item.label}
                                </a>
                              </h3>
                            </GridColumn>

                            <GridColumn mobile={14} tablet={14} computer={14}>
                              <p className="nhrankingDesc">Coming soon</p>
                            </GridColumn>
                          </Grid.Row>
                        </Grid>
                      </GridColumn>
                    </GridRow>
                  )}
                </>
              );
            })}
          </Grid>
          {loading ? <p>Loading...</p> : ""}
        </div>
      )}
    </>
  );
};

NhrankingList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default NhrankingList;
